import { render, staticRenderFns } from "./NewRow.vue?vue&type=template&id=1fb82d90"
import script from "./NewRow.vue?vue&type=script&lang=ts"
export * from "./NewRow.vue?vue&type=script&lang=ts"
import style0 from "./NewRow.vue?vue&type=style&index=0&id=1fb82d90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports